'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Icon } from '@/components/ui/icon';
import { LinkForwardIconSolid } from '@/components/ui/icon/glyphs';
import { withDemoMode } from '@/lib/network';
import { useUserNetwork } from '@/lib/network/client';
import { ShareModal } from '@/lib/share';
interface StreakShareButtonProps {
  userId: string;
  /** Current day count — drives the share text ("…{count} day streak…"). */
  currentStreak: number;
}

/**
 * Icon-only trigger that opens the share modal for the user's trading
 * streak. The modal preview renders the `streak` OG card; the share URL
 * points at the owner's portfolio (matching the rank / profile share
 * convention). Sized `xl` to match the sibling "View calendar" button.
 */
export function StreakShareButton(t0) {
  const $ = _c(21);
  const {
    userId,
    currentStreak
  } = t0;
  const t = useTranslations("streaks");
  const {
    network
  } = useUserNetwork();
  let t1;
  bb0: {
    if (typeof window === "undefined") {
      t1 = "";
      break bb0;
    }
    let t2;
    if ($[0] !== network || $[1] !== userId) {
      const u = new URL(`/portfolio/${userId}`, window.location.origin);
      withDemoMode(u, network === "mainnet" ? "mainnet" : "devnet");
      u.searchParams.set("streak", "1");
      t2 = u.toString();
      $[0] = network;
      $[1] = userId;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = t2;
  }
  const url = t1;
  let t2;
  if ($[3] !== userId) {
    t2 = {
      kind: "streak",
      userId
    };
    $[3] = userId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== currentStreak || $[6] !== t) {
    t3 = t("share_text", {
      count: currentStreak
    });
    $[5] = currentStreak;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("share_title");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("share_aria");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Icon icon={LinkForwardIconSolid} className="size-5" aria-hidden="true" />;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5) {
    t7 = <AnimatedButton variant="secondary" size="xl" aria-label={t5}>{t6}</AnimatedButton>;
    $[13] = t5;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t7 || $[19] !== url) {
    t8 = <ShareModal surface={t2} url={url} text={t3} title={t4} trigger={t7} />;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t7;
    $[19] = url;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}